module.exports = __webpack_public_path__ + "static/media/pallete.304af91b.svg";